import { render, staticRenderFns } from "./LogsCard.vue?vue&type=template&id=0ce6fb2e&scoped=true"
import script from "./LogsCard.vue?vue&type=script&lang=js"
export * from "./LogsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce6fb2e",
  null
  
)

export default component.exports